__turbopack_context__.v({
  "Remove": "image-uploader-module__yGMnGq__Remove",
  "Upload": "image-uploader-module__yGMnGq__Upload",
  "UploadButton": "image-uploader-module__yGMnGq__UploadButton",
  "UploadText": "image-uploader-module__yGMnGq__UploadText",
  "UploadedImage": "image-uploader-module__yGMnGq__UploadedImage",
  "UploadedWrapper": "image-uploader-module__yGMnGq__UploadedWrapper",
});
